import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// React Router doesn't reset scroll position on navigation (it's not a real
// page load) — without this, a new route opens wherever the previous page
// happened to be scrolled to. Skip it when there's a hash: that means a page
// wants to scroll to a specific section itself (see Landing's hash effect).
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}
